<template>
  <div class="padbox">
    <div v-if="quan_xia == 2">
      <div style="padding: 20px">
        <el-row :gutter="20">
          <el-col style="width: 20%">
            <div class="text_align" @click="clickNum(0, null)">
              <div class="text_name">待支付</div>
              <div>{{ OrderNum.unpaidNum || 0 }}</div>
            </div>
          </el-col>
          <el-col style="width: 20%">
            <div class="text_align" @click="clickNum(1, null)">
              <div class="text_name">待发货</div>
              <div>{{ OrderNum.deliverNum || 0 }}</div>
            </div>
          </el-col>
          <el-col style="width: 20%">
            <div class="text_align" @click="clickNum(2, null)">
              <div class="text_name">待收货</div>
              <div>{{ OrderNum.waitForReceivingNum || 0 }}</div>
            </div>
          </el-col>
          <el-col style="width: 20%">
            <div class="text_align" @click="clickNum(3, null)">
              <div class="text_name">已完成</div>
              <div>{{ OrderNum.finishNum || 0 }}</div>
            </div>
          </el-col>
          <el-col style="width: 20%">
            <div class="text_align" @click="clickNum(7, null)">
              <div class="text_name">已取消</div>
              <div>{{ OrderNum.cancelNum || 0 }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col
          :span="8"
          style="border-right: 1px solid rgba(252, 140, 35, 0.2); height: 580px"
        >
          <div style="color: #000; text-align: center; margin-top: 40px">
            商品浏览量统计
          </div>
          <div style="margin: 20px; padding: 10px 0; border-radius: 4px">
            <div class="cus_table">
              <el-row>
                <el-col class="webkit-box">商品名</el-col>
                <el-col class="webkit-box">浏览量</el-col>
              </el-row>
            </div>
            <div
              v-for="(item, index) in Goodslist"
              :key="index"
              class="cus_table"
            >
              <el-row>
                <el-col class="webkit-box">{{ item.name }}</el-col>
                <el-col class="webkit-box" style="color: #42ca4d">
                  <span @click="clickNum(10, item)" class="cursor">
                    {{ item.pageView }}</span
                  >
                </el-col>
              </el-row>
            </div>
            <el-pagination
              :page-size="queryParams.Goods_pageSize"
              :current-page="queryParams.Goods_pageNum"
              layout="prev, pager, next"
              :total="queryParams.Goods_total"
              @current-change="changecurrentgoods"
            >
            </el-pagination>
          </div>
        </el-col>
        <el-col
          :span="8"
          style="border-right: 1px solid rgba(252, 140, 35, 0.2); height: 580px"
        >
          <div style="color: #000; text-align: center; margin-top: 40px">
            用户浏览量统计
          </div>
          <div style="margin: 20px; padding: 10px 0; border-radius: 4px">
            <div class="cus_table">
              <el-row>
                <el-col class="webkit-box">用户名</el-col>
                <el-col class="webkit-box">浏览量</el-col>
              </el-row>
            </div>
            <div
              v-for="(item, index) in BrowseNum"
              :key="index"
              class="cus_table"
            >
              <el-row>
                <el-col class="webkit-box">{{ item.nickName }}</el-col>
                <el-col class="webkit-box" style="color: #42ca4d">
                  <span @click="clickNum(8, item)" class="cursor">
                    {{ item.num }}</span
                  >
                </el-col>
              </el-row>
            </div>
            <el-pagination
              :page-size="queryParams.Browse_pageSize"
              :current-page="queryParams.Browse_pageNum"
              layout="prev, pager, next"
              :total="queryParams.Browse_total"
              @current-change="changecurrentbrowse"
            >
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="8">
          <div style="color: #000; text-align: center; margin-top: 40px">
            购物车件数统计
          </div>
          <div style="margin: 20px; padding: 10px 0; border-radius: 4px">
            <div class="cus_table">
              <el-row>
                <el-col class="webkit-box">用户名</el-col>
                <el-col class="webkit-box">购物车件数</el-col>
              </el-row>
            </div>
            <div
              v-for="(item, index) in CartNum"
              :key="index"
              class="cus_table"
            >
              <el-row>
                <el-col class="webkit-box">{{ item.nickName }}</el-col>
                <el-col class="webkit-box" style="color: #42ca4d">
                  <span @click="clickNum(9, item)" class="cursor">
                    {{ item.num }}</span
                  ></el-col
                >
              </el-row>
            </div>
            <el-pagination
              :page-size="queryParams.Cart_pageSize"
              :current-page="queryParams.Cart_pageNum"
              layout="prev, pager, next"
              :total="queryParams.Cart_total"
              @current-change="changecurrentcart"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>

      <el-dialog
        title="浏览详情"
        :visible.sync="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
        append-to-body
        :before-close="handleClose"
      >
        <el-table
          ref="multipleTable"
          :data="Browselist"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column
            prop="cover"
            width="100"
            align="center"
            label="商品封面"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 70px; height: 70px"
                :src="scope.row.cover"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="商品名" align="center" prop="name">
          </el-table-column>
          <el-table-column
            prop="typeName"
            align="center"
            label="商品类型"
            width="148"
          >
            <template slot-scope="{ row }">
              {{ row.firstClassifyName }}/ {{ row.classifyName }}
            </template>
          </el-table-column>
          <el-table-column
            label="浏览量"
            align="center"
            prop="num"
            width="160"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="Params.Browse_pageNum"
          :page-size="Params.Browse_pageSize"
          :total="Params.Browse_total"
        >
        </el-pagination>
      </el-dialog>

      <el-dialog
        title="用户购物车商品件数"
        :visible.sync="Visible"
        width="80%"
        :close-on-click-modal="false"
        append-to-body
        :before-close="handleClose"
      >
        <el-table
          ref="multipleTable"
          :data="Browselist"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column
            prop="cover"
            width="100"
            align="center"
            label="商品封面"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 70px; height: 70px"
                :src="scope.row.cover"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="商品名" align="center" prop="name">
          </el-table-column>
          <el-table-column
            prop="typeName"
            align="center"
            label="规格"
            width="148"
          >
            <template slot-scope="{ row }">
              {{ row.commoditSpecifications }}
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            prop="num"
            width="160"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeCart"
          @current-change="handleCurrentChangeCart"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="Params.Cart_pageNum"
          :page-size="Params.Cart_pageSize"
          :total="Params.Cart_total"
        >
        </el-pagination>
      </el-dialog>

      <el-dialog
        title="用户"
        :visible.sync="Visibleuser"
        width="80%"
        :close-on-click-modal="false"
        append-to-body
        :before-close="handleClose"
      >
        <el-table
          ref="multipleTable"
          :data="Userlist"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column prop="cover" width="100" align="center" label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 70px; height: 70px"
                :src="scope.row.avatarUrl"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户名" align="center" prop="nickName">
          </el-table-column>
          <el-table-column label="手机号" align="center" prop="phone">
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            prop="num"
            width="160"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeUser"
          @current-change="handleCurrentChangeUser"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="Params.User_pageNum"
          :page-size="Params.User_pageSize"
          :total="Params.User_total"
        >
        </el-pagination>
      </el-dialog>

      <el-dialog
        title="订单列表"
        :visible.sync="orderVisible"
        width="80%"
        :close-on-click-modal="false"
        append-to-body
        :before-close="handleClose"
      >
        <el-table
          ref="multipleTable"
          :data="Ordlist"
          style="width: 100%"
          border
          stripe
        >
          <el-table-column
            label="订单号"
            align="center"
            prop="orderCode"
            width="240"
          ></el-table-column>
          <el-table-column
            label="订单状态"
            align="center"
            prop="orderState"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag
                size="small"
                v-if="scope.row.orderType == 1"
                type="success"
                >待发货
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 2"
                type="success"
                >待收货
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 3"
                type="success"
                >已完成
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 4"
                type="success"
                >退款中
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 5"
                type="success"
                >已退款
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 6"
                type="success"
                >退款驳回
              </el-tag>
              <el-tag
                size="small"
                v-else-if="scope.row.orderType == 7"
                type="success"
                >已取消
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="用户名"
            align="center"
            prop="createUserName"
            width="240"
          ></el-table-column>
          <el-table-column
            label="收货人"
            align="center"
            prop="name"
            width="240"
          ></el-table-column>
          <el-table-column
            label="收货地址"
            align="center"
            prop="deliveryMethod"
            width="240"
          >
            <template slot-scope="scope">
              {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.county
              }}{{ scope.row.address }}
            </template>
          </el-table-column>

          <el-table-column
            label="物流单号"
            align="center"
            prop="logisticsNumber"
            width="240"
          ></el-table-column>
          <el-table-column
            label="下单时间"
            align="center"
            prop="payTime"
            width="200"
          ></el-table-column>
          <el-table-column
            label="金额"
            align="center"
            prop="realPayment"
            width="120"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChangeOrder"
          @current-change="handleCurrentChangeOrder"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="Params.Order_pageNum"
          :page-size="Params.Orde_pageSize"
          :total="Params.Order_total"
        >
        </el-pagination>
      </el-dialog>
    </div>
    <div v-if="quan_xia == 3" class="cus_title">平文优选后台管理系统</div>
  </div>
</template>
<script>
export default {
  name: "Index",
  components: {},
  data() {
    return {
      quan_xia: 1,
      type: null,
      userId: null,
      Visible: false,
      dialogVisible: false,
      Visibleuser: false,
      OrderNum: {},
      BrowseNum: [],
      CartNum: [],
      Ordlist: [],
      Userlist: [],
      Goodslist: [],
      Browselist: [],
      orderVisible: false,
      queryParams: {
        Browse_pageNum: 1,
        Browse_pageSize: 10,
        Browse_total: 0,
        Cart_pageNum: 1,
        Cart_pageSize: 10,
        Cart_total: 0,
        Goods_pageNum: 1,
        Goods_pageSize: 10,
        Goods_total: 0,
      },
      userInfo: {},
      Params: {
        Browse_pageNum: 1,
        Browse_pageSize: 10,
        Browse_total: 0,
        Cart_pageNum: 1,
        Cart_pageSize: 10,
        Cart_total: 0,
        Order_pageNum: 1,
        Order_pageSize: 10,
        Order_total: 0,
        User_pageNum: 1,
        User_pageSize: 10,
        User_total: 0,
      },
    };
  },
  created() {
    this.getUserInfo();
    this.ushows();
    this.browse();
    this.cart();
    this.shoplist();
  },
  methods: {
    getUserInfo() {
      this.$axios.post("/admin/user/userInfo").then((res) => {
        this.userInfo = res.data;
        if (res.data.username == "admin") {
          this.quan_xia = 2;
        } else {
          this.quan_xia = 3;
        }
      });
    },
    clickNum(i, o) {
      if (i == 8) {
        this.userId = o.userId;
        this.Params.Browse_pageNum = 1;
        this.Params.Browse_pageSize = 10;
        this.dialogVisible = true;
        this.brolist();
        return false;
      }

      if (i == 9) {
        this.userId = o.userId;
        this.Params.Cart_pageNum = 1;
        this.Params.Cart_pageSize = 10;
        this.Visible = true;
        this.cartlist();
        return false;
      }
      if (i == 10) {
        this.userId = o.id;
        this.Params.User_pageNum = 1;
        this.Params.User_pageSize = 10;
        this.Visibleuser = true;
        this.userlist();
        return false;
      }
      this.type = i;
      this.Params.Order_pageNum = 1;
      this.Params.Order_pageSize = 10;
      this.orderVisible = true;
      this.getOrdlist();
    },
    shoplist() {
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", {
          pageNo: this.Params.Goods_pageNum,
          pageSize: this.Params.Goods_pageSize,
          type: 0,
        })
        .then((res) => {
          this.Goodslist = res.data.records;
          this.Goods_total = res.data.total;
        });
    },

    brolist() {
      this.$axios
        .post("/admin/num/getBrowseList", {
          pageNo: this.Params.Browse_pageNum,
          pageSize: this.Params.Browse_pageSize,
          userId: this.userId,
        })
        .then((res) => {
          this.Browselist = res.data.records;
          this.Params.Browse_total = res.data.total;
        });
    },

    cartlist() {
      this.$axios
        .post("/admin/num/getShoppingCartList", {
          pageNo: this.Params.Cart_pageNum,
          pageSize: this.Params.Cart_pageSize,
          userId: this.userId,
        })
        .then((res) => {
          this.Browselist = res.data.records;
          this.Params.Browse_total = res.data.total;
        });
    },

    getOrdlist() {
      this.$axios
        .post("/admin/order/getOrderList", {
          pageNo: this.Params.Order_pageNum,
          pageSize: this.Params.Order_pageSize,
          orderType: this.type,
        })
        .then((res) => {
          this.Ordlist = res.data.records;
          this.Params.Order_total = res.data.total;
        });
    },
    userlist() {
      this.$axios
        .post("/admin/num/getUserBrowseNum", {
          pageNo: this.Params.User_pageNum,
          pageSize: this.Params.User_pageSize,
          id: this.userId,
        })
        .then((res) => {
          this.Userlist = res.data.records;
          this.Params.User_total = res.data.total;
        });
    },
    handleSizeChange(i) {
      this.Params.Browse_pageSize = i;
      this.brolist();
    },

    handleCurrentChange(i) {
      this.Params.Browse_pageNum = i;
      this.brolist();
    },
    handleSizeChangeCart(i) {
      this.Params.Cart_pageSize = i;
      this.cartlist();
    },

    handleCurrentChangeUser(i) {
      this.Params.User_pageNum = i;
      this.userlist();
    },

    handleSizeChangeUser(i) {
      this.Params.User_pageSize = i;
      this.userlist();
    },

    handleCurrentChangeCart(i) {
      this.Params.Cart_pageNum = i;
      this.cartlist();
    },

    handleSizeChangeOrder(i) {
      this.Params.Order_pageSize = i;
      this.getOrdlist();
    },

    handleCurrentChangeOrder(i) {
      this.Params.Order_pageNum = i;
      this.getOrdlist();
    },

    handleClose() {
      this.Params.Browse_pageNum = 1;
      this.Params.Browse_pageSize = 10;
      this.Params.Cart_pageNum = 1;
      this.Params.Cart_pageSize = 10;
      this.Params.User_pageNum = 1;
      this.Params.User_pageSize = 10;
      this.Params.Order_pageNum = 1;
      this.Params.Order_pageSize = 10;
      this.dialogVisible = false;
      this.Visible = false;
      this.orderVisible = false;
      this.Visibleuser = false;
    },
    ushows() {
      this.$axios.get("/admin/num/getOrderNum").then((res) => {
        this.OrderNum = res.data;
      });
    },
    changecurrentcart(i) {
      this.queryParams.Cart_pageNum = i;
      this.cart();
    },
    changecurrentgoods(i) {
      this.queryParams.Goods_pageNum = i;
      this.browse();
    },
    changecurrentbrowse(i) {
      this.queryParams.Browse_pageNum = i;
      this.browse();
    },
    browse() {
      this.$axios
        .post("/admin/num/getBrowseNum", {
          pageNo: this.queryParams.Browse_pageNum,
          pageSize: this.queryParams.Browse_pageSize,
        })
        .then((res) => {
          this.BrowseNum = [];
          for (let i = 0; i < 10; i++) {
            if (res.data.records[i]) {
              this.BrowseNum.push(res.data.records[i]);
            } else {
              this.BrowseNum.push({});
            }
          }
          this.queryParams.Browse_total = res.data.total;
        });
    },

    cart() {
      this.$axios
        .post("/admin/num/getShoppingCartNum", {
          pageNo: this.queryParams.Cart_pageNum,
          pageSize: this.queryParams.Cart_pageSize,
        })
        .then((res) => {
          this.CartNum = [];
          for (let i = 0; i < 10; i++) {
            if (res.data.records[i]) {
              this.CartNum.push(res.data.records[i]);
            } else {
              this.CartNum.push({});
            }
          }
          this.queryParams.Cart_total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.cus_title {
  text-align: center;
  padding-top: 30vh;
  color: #fc8c23;
  font-size: 40px;
}

.padbox {
  /* box-sizing: border-box;
  background-image: url("../assets/index_Bg.jpeg");
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  height: calc(100vh - 120px);
  border-radius: 2px; */
  background: #fff;
  width: 100%;
  height: calc(100vh - 120px);
}

.cus_table {
  text-align: center;
  color: #000;
  line-height: 40px;
  height: 40px;
}

.text_align {
  text-align: center;
  background-color: #fc8c23;
  padding: 12px 0;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
}

.text_name {
  margin-bottom: 10px;
  font-size: 18px;
}

.webkit-box {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 50%;
}

/deep/ .el-pagination {
  text-align: center;
  float: none !important;
  margin-top: 10px;
}

/deep/ .active {
  color: #42ca4d !important;
  cursor: pointer;
}

.cursor {
  cursor: pointer;
}
</style>
